/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gYEVvAzCcLMHDVPvuYxkFh
// Component: 4AYfEug-RA

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_styles_pane.css"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/projectcss
import sty from "./PlasmicColorSwatch.module.css"; // plasmic-import: 4AYfEug-RA/css

createPlasmicElementProxy;

export type PlasmicColorSwatch__VariantMembers = {
  isSelected: "isSelected";
};
export type PlasmicColorSwatch__VariantsArgs = {
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
};
type VariantPropType = keyof PlasmicColorSwatch__VariantsArgs;
export const PlasmicColorSwatch__VariantProps = new Array<VariantPropType>(
  "isSelected"
);

export type PlasmicColorSwatch__ArgsType = {};
type ArgPropType = keyof PlasmicColorSwatch__ArgsType;
export const PlasmicColorSwatch__ArgProps = new Array<ArgPropType>();

export type PlasmicColorSwatch__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  checker?: Flex__<"div">;
  bgOpacity?: Flex__<"div">;
  color?: Flex__<"div">;
  border?: Flex__<"div">;
};

export interface DefaultColorSwatchProps {
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  className?: string;
}

const $$ = {};

function PlasmicColorSwatch__RenderFunc(props: {
  variants: PlasmicColorSwatch__VariantsArgs;
  args: PlasmicColorSwatch__ArgsType;
  overrides: PlasmicColorSwatch__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isSelected,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_gYEVvAzCcLMHDVPvuYxkFh",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootisSelected]: hasVariant($state, "isSelected", "isSelected") }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox, {
          [sty.freeBoxisSelected]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
        })}
      >
        <div
          data-plasmic-name={"checker"}
          data-plasmic-override={overrides.checker}
          className={classNames("all", sty.checker, {
            [sty.checkerisSelected]: hasVariant(
              $state,
              "isSelected",
              "isSelected"
            ),
          })}
        >
          <div
            data-plasmic-name={"bgOpacity"}
            data-plasmic-override={overrides.bgOpacity}
            className={classNames("all", sty.bgOpacity, {
              [sty.bgOpacityisSelected]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
            })}
          />

          <div
            data-plasmic-name={"color"}
            data-plasmic-override={overrides.color}
            className={classNames("all", sty.color, {
              [sty.colorisSelected]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
            })}
          />

          <div
            data-plasmic-name={"border"}
            data-plasmic-override={overrides.border}
            className={classNames("all", sty.border, {
              [sty.borderisSelected]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
            })}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "checker", "bgOpacity", "color", "border"],
  freeBox: ["freeBox", "checker", "bgOpacity", "color", "border"],
  checker: ["checker", "bgOpacity", "color", "border"],
  bgOpacity: ["bgOpacity"],
  color: ["color"],
  border: ["border"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  checker: "div";
  bgOpacity: "div";
  color: "div";
  border: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicColorSwatch__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicColorSwatch__VariantsArgs;
    args?: PlasmicColorSwatch__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicColorSwatch__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicColorSwatch__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicColorSwatch__ArgProps,
          internalVariantPropNames: PlasmicColorSwatch__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicColorSwatch__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicColorSwatch";
  } else {
    func.displayName = `PlasmicColorSwatch.${nodeName}`;
  }
  return func;
}

export const PlasmicColorSwatch = Object.assign(
  // Top-level PlasmicColorSwatch renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    checker: makeNodeComponent("checker"),
    bgOpacity: makeNodeComponent("bgOpacity"),
    color: makeNodeComponent("color"),
    border: makeNodeComponent("border"),

    // Metadata about props expected for PlasmicColorSwatch
    internalVariantProps: PlasmicColorSwatch__VariantProps,
    internalArgProps: PlasmicColorSwatch__ArgProps,
  }
);

export default PlasmicColorSwatch;
/* prettier-ignore-end */
